"use strict";

angular.module('PatientApp').directive('messageAttachmentInput', ['$parse', '$timeout', function ($parse, $timeout) {
  return {
    require: 'ngModel',
    link: function link(scope, elem, attrs, ngModel) {
      elem.on('change', function () {
        var files = elem[0].files;
        var currentFiles = scope.messageDetails.attachments;
        var fileArray = [];
        angular.forEach(currentFiles, function (file) {
          if (fileArray.length < 3) {
            fileArray.push(file);
          } else if (scope.errorNotifications) {
            scope.errorNotifications.tooManyFiles = true;
          } else if (scope.attachmentErrors) {
            scope.attachmentErrors.tooManyFiles = true;
          }
        });
        angular.forEach(files, function (file) {
          if (fileArray.length < 3) {
            fileArray.push(file);
          } else if (scope.errorNotifications) {
            scope.errorNotifications.tooManyFiles = true;
          } else if (scope.attachmentErrors) {
            scope.attachmentErrors.tooManyFiles = true;
          }
        });
        ngModel.$setViewValue(fileArray);
        elem[0].value = null;
      });
      var model = $parse(attrs.focus);
      scope.$watch(model, function (value) {
        if (value) {
          $timeout(function () {
            elem[0].click(); // trigger file input prompt
          });
        }
      });
    }
  };
}]);